import { configType } from "../types/configType";
let sandboxExport: any;
let stagingExport: any;
if (process.env.REACT_APP_ENVIRONMENT === "development") {
  let sandbox: configType = require("./sandbox.json");
  sandboxExport = sandbox;
}
if (process.env.REACT_APP_ENVIRONMENT === "staging") {
  let staging: configType = require("./staging.json");
  stagingExport = staging;
}
const production: configType = {
  environment: "production",
  s3: {
    REGION: process.env.REACT_APP_PRODUCTION_REGION,
    BUCKET: process.env.REACT_APP_PRODUCTION_S3_BUCKETCREATIVES,
  },
  apiGateway: {
    REGION: process.env.REACT_APP_PRODUCTION_REGION,
    URL: process.env.REACT_APP_PRODUCTION_APIGATEWAY_URL,
  },
  cognito: {
    REGION: process.env.REACT_APP_PRODUCTION_REGION,
    USER_POOL_ID: process.env.REACT_APP_PRODUCTION_COGNITO_USERPOOLID,
    APP_CLIENT_ID: process.env.REACT_APP_PRODUCTION_COGNITO_APPCLIENTID,
    IDENTITY_POOL_ID: process.env.REACT_APP_PRODUCTION_COGNITO_IDENTITYPOOLID,
  },
  slack: {
    PINOCCHIBOT: process.env.REACT_APP_PRODUCTION_SLACK_TOKENPINOCCHIBOT,
    FEEDBACKFRIDA: process.env.REACT_APP_PRODUCTION_SLACK_TOKENFEEDBACKFRIDA,
    MUMFORD: process.env.REACT_APP_PRODUCTION_SLACK_TOKENMUMFORD,
    TAGS_CHANNEL: process.env.REACT_APP_PRODUCTION_SLACK_CHANNELTAGS,
    FEEDBACK_CHANNEL: process.env.REACT_APP_PRODUCTION_SLACK_CHANNELFEEDBACK,
    LOGS_CHANNEL: process.env.REACT_APP_PRODUCTION_SLACK_CHANNELLOGS,
    URL: process.env.REACT_APP_PRODUCTION_SLACK_APIGATEWAYURL,
    STUDIO_SUPPORT_CHANNEL: process.env.REACT_APP_PRODUCTION_SLACK_STUDIO_SUPPORT_CHANNEL,
    STUDIO_FEEDBACK_CHANNEL: process.env.REACT_APP_PRODUCTION_SLACK_STUDIO_FEEDBACK_CHANNEL,
  },
  logging: {
    ENABLED: process.env.REACT_APP_PRODUCTION_LOGGING_ENABLED,
  },
  preview: {
    URL: process.env.REACT_APP_PRODUCTION_PREVIEW_URL,
  },
  analytics: {
    DISABLED: false, // (HTL - 05-09-22 - Analytics should always be enabled for production environment).
    REGION: process.env.REACT_APP_PRODUCTION_REGION,
    FIREHOSESTREAMNAME: process.env.REACT_APP_PRODUCTION_ANALYTICS_FIREHOSESTREAMNAME,
  },
  managedServiceTeamIds: ["pi6j", "3ad5", "5b3w", "t0b2", "t1m3"],
};

let config;
if (process.env.REACT_APP_ENVIRONMENT === "production") {
  config = production;
} else if (process.env.REACT_APP_ENVIRONMENT === "staging") {
  config = stagingExport;
} else {
  config = sandboxExport;
}

export default config;
